const SupplierInfo = () => import(/* webpackChunkName: "supplier" */ '@/modules/supplier/views/SupplierInfo')
const SupplierPreview = () => import(/* webpackChunkName: "supplier" */ '@/modules/supplier/views/SupplierPreview')

export default [
  {
    path: '/suppliers/:id',
    name: 'SupplierInfo',
    component: SupplierInfo
  },
  {
    path: '/suppliers/:id/preview',
    name: 'SupplierPreview',
    component: SupplierPreview
  }
]
